import { all } from "redux-saga/effects";
import {getGamesWatcher} from "./getGames.saga";
import {getGameBundlesWatcher} from "./getGameBundles.saga";
import { getSubsidiariesWatcher } from "./getSubsidiaries.saga";
import { getPresetsWatcher, getPresetWatcher } from "./getPresets.saga";
import {
    addPresetWatcher,
    editPresetWatcher,
    togglePresetActiveStateWatcher,
    toggleCertifiedPresetWatcher
} from "./addPreset.saga";
import { getDenominationsWatcher } from "./getDenominations.saga";

export default function* rootSaga() {
    yield all([
        getSubsidiariesWatcher(),
        getPresetsWatcher(),
        addPresetWatcher(),
        getPresetWatcher(),
        editPresetWatcher(),
        getDenominationsWatcher(),
        togglePresetActiveStateWatcher(),
        toggleCertifiedPresetWatcher(),
        getGamesWatcher(),
        getGameBundlesWatcher()
    ]);
}
